"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nodeListToArray(elements) {
    var array = [];
    for (var i = 0, length = elements.length; i < length; i++) {
        var element = elements.item(i);
        if (element instanceof HTMLElement) {
            array.push(element);
        }
    }
    return array;
}
exports.nodeListToArray = nodeListToArray;



//////////////////
// WEBPACK FOOTER
// ./src/utils/HTMLUtils.ts
// module id = 7
// module chunks = 13 14